import { Suggestion } from 'types/suggestions';

export const getSanitizedValue = (suggestion: Suggestion | null) => {
  if (!suggestion) return null;
  if ('name' in suggestion && suggestion.name) return suggestion.name;
  return null;
};
